module.exports = __webpack_public_path__ + "assets/img/sheji.f448f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activities/desiagner/sheji.png
// module id = XeUV
// module chunks = 1